import {endpoints} from './endpoints'
import request from '../request'

export function login (email, pass) {
	return new Promise((resolve, reject) => {
		const data = {
			email: email,
			password: pass
		}
		request({
			url: endpoints.login,
			method: 'post',
			data
		})
			.then(async function (response) {
				setUserToken(response)
				await getUser()
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function update (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.update,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function register (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.register,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				console.log('error: ', error)
				reject(error)
			})
	})
}

function setUserToken (token) {
	localStorage.setItem('userToken', token.access_token)
}

export function resendVerificationEmail (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.resendVerificationEmail,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getUser() {
	return new Promise((resolve) => {
		request({
			url: endpoints.userInfo,
			method: 'get'
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				resolve(error)
			})
	})
}

export function updateUser(data) {
	return new Promise((resolve) => {
		request({
			url: endpoints.updateUser,
			method: 'post',
			data
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				resolve(error)
			})
	})
}

export function resetPassRequest(data) {
	return new Promise((resolve) => {
		request({
			url: endpoints.resetPassRequest,
			method: 'post',
			data
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				resolve(error)
			})
	})
}

export function checkToken(data) {
	return new Promise((resolve) => {
		request({
			url: endpoints.checkToken,
			method: 'post',
			data
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				resolve(error)
			})
	})
}

export function resetPass(data) {
	return new Promise((resolve) => {
		request({
			url: endpoints.resetPass,
			method: 'post',
			data
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				resolve(error)
			})
	})
}

export function loginWithGoogleToken (access_token) {
	return new Promise((resolve, reject) => {
		const data = {access_token}
		
		request({
			url: endpoints.loginWithGoogleToken,
			method: 'post',
			data
		})
			.then(async function (response) {
				setUserToken(response)
				await getUser()
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function setUserBillingInfo(data) {
	return new Promise((resolve) => {
		request({
			url: endpoints.setUserBillingInfo,
			method: 'post',
			data
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				resolve(error)
			})
	})
}

export function getUserBillingInfo(data) {
	return new Promise((resolve) => {
		request({
			url: endpoints.getUserBillingInfo,
			method: 'post',
			data
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				resolve(error)
			})
	})
}

export function setSimpleSignature(data) {
	return new Promise((resolve) => {
		request({
			url: endpoints.setSimpleSignature,
			method: 'post',
			data
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				resolve(error)
			})
	})
}

export function updateOrCreateBankAccount(data) {
	return new Promise((resolve) => {
		request({
			url: endpoints.updateOrCreateBankAccount,
			method: 'post',
			data
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				resolve(error)
			})
	})
}

export function setAccountCompanyProfile(data) {
	return new Promise((resolve) => {
		request({
			url: endpoints.setAccountCompanyProfile,
			method: 'post',
			data
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				resolve(error)
			})
	})
}

export function setCompanyAccreditationUserStatus(data) {
	return new Promise((resolve) => {
		request({
			url: endpoints.setCompanyAccreditationUserStatus,
			method: 'post',
			data
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				resolve(error)
			})
	})
}